import { useEffect } from 'react';

import cookie from 'react-cookies';
import { useNavigate } from 'react-router-dom';

import './Home.css';

function Welcome() {
  const navigate = useNavigate();

  useEffect(() => {
    const token = cookie.load('lendistry_tokens_access');
    if (token) {
      navigate('/dashboard');
    } else {
      navigate('/landing');
    }
  }, []);

  return '';
}

export default Welcome;
